const lang = {
  component: {
    ChatbotPopup: {
      pTagFirst: `Bonjour, je suis Alma.`,
      pTagSecond: `J'ai été créé pour répondre à vos questions sur`,
      pTagThird: `croissance de l'enfant`,
      pTagFourth: `. En quoi puis-je vous aider?`,
      button: {
        copy: `Demandez à Alma`,
        label: `Poser une question`
      }
    },
    Chatbot: {
      promptBtnLabel: `Discutez avec Alma`,
      disclaimer: `Les informations que vous partagez nous aident à fournir des réponses utiles pour plus d'informations, consultez notre`,
      privacyPolicy: `politique de confidentialité`,
      submitBtnTxt: `Envoyer`
    }
  }
};

export default lang;
